import { gql } from '@apollo/client';

import { CORE_ORGANIZATION_FIELDS } from './fragments';

export const listOrganizations = gql`
  ${CORE_ORGANIZATION_FIELDS}
  query listOrganizations($pagination: PaginationInput) {
    listOrganizations(pagination: $pagination) {
      ...CoreOrganizationFields
      subscription {
        id
        expirationDate
        product {
          id
          name {
            languageCode
            value
          }
          catalogs {
            id
          }
        }
        status
        validFrom
        validTo
        seats
        invoice
      }
    }
  }
`;

export const listCourses = gql`
  query listCourses(
    $pagination: PaginationInput
    $filter: CourseFilter
    $organizationId: ID
  ) {
    listCourses(
      pagination: $pagination
      filter: $filter
      organizationId: $organizationId
    ) {
      id
      name {
        languageCode
        languageId
        value
      }
      archivedScheduledAt
    }
  }
`;

export const listFeaturedCourses = gql`
  query listFeaturedCourses($filter: FeaturedCoursesFilter) {
    listFeaturedCourses(filter: $filter) {
      id
      name {
        languageCode
        languageId
        value
      }
    }
  }
`;

export const validateVideocationCatalogRemoval = gql`
  query validateVideocationCatalogRemoval($organizationId: ID!) {
    validateVideocationCatalogRemoval(organizationId: $organizationId) {
      allowed
      hasPlaylistsWithVideocationCourses
      hasVideocationCoursesFeatured
      hasFeaturedCourse
    }
  }
`;
